// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../styles/interview-theme.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================
   CONTACT SUPPORT MODAL - G42 BRANDING
   ========================================== */

/* Contact Support Modal Overlay */
.support-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: var(--interview-z-modal);
  padding: var(--interview-space-xl);
  animation: support-fadeIn var(--interview-transition-base) ease-out;
  font-family: var(--interview-font-primary);
}

@keyframes support-fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Modal Container */
.support-modal {
  background: var(--interview-bg-white);
  border-radius: var(--interview-radius-2xl);
  max-width: 520px;
  width: 100%;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: support-slideUp var(--interview-transition-slow) ease-out;
}

@keyframes support-slideUp {
  from {
    transform: translateY(30px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

/* Header */
.support-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--interview-space-2xl) var(--interview-space-3xl);
  border-bottom: 1px solid var(--interview-border-default);
}

.support-title {
  font-size: 1.5rem;
  font-weight: var(--interview-text-bold);
  color: var(--interview-text-primary);
  margin: 0;
  letter-spacing: -0.02em;
}

.support-closeButton {
  background: none;
  border: none;
  font-size: 2rem;
  color: var(--interview-text-muted);
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--interview-radius-sm);
  transition: all var(--interview-transition-base);
  line-height: 1;
}

.support-closeButton:hover {
  background: var(--interview-bg-card);
  color: var(--interview-text-primary);
}

/* Content */
.support-content {
  padding: var(--interview-space-3xl);
}

.support-intro {
  font-size: var(--interview-text-base);
  color: var(--interview-text-muted);
  margin: 0 0 var(--interview-space-2xl) 0;
  line-height: 1.6;
  font-weight: var(--interview-text-regular);
}

.support-contacts {
  display: flex;
  flex-direction: column;
  gap: var(--interview-space-xl);
}

.support-contactItem {
  padding: var(--interview-space-lg);
  background: var(--interview-bg-card);
  border-radius: var(--interview-radius-md);
  border: 1px solid var(--interview-border-default);
  transition: all var(--interview-transition-base);
}

.support-contactItem:hover {
  background: var(--interview-bg-input);
  border-color: var(--interview-border-light);
}

.support-contactName {
  font-size: var(--interview-text-base);
  font-weight: var(--interview-text-semibold);
  color: var(--interview-text-primary);
  margin-bottom: var(--interview-space-sm);
  letter-spacing: -0.01em;
}

.support-contactEmail {
  font-size: 0.875rem;
  color: var(--interview-brand-primary);
  text-decoration: none;
  display: inline-block;
  transition: all var(--interview-transition-base);
  font-weight: var(--interview-text-medium);
}

.support-contactEmail:hover {
  color: var(--interview-brand-primary-dark);
  text-decoration: underline;
}

/* Footer */
.support-footer {
  padding: var(--interview-space-xl) var(--interview-space-3xl);
  border-top: 1px solid var(--interview-border-default);
  display: flex;
  justify-content: flex-end;
}

.support-closeButtonBottom {
  background: var(--interview-brand-primary);
  color: var(--interview-bg-white);
  border: none;
  border-radius: var(--interview-radius-md);
  padding: var(--interview-space-md) 28px;
  font-size: var(--interview-text-base);
  font-weight: var(--interview-text-semibold);
  cursor: pointer;
  transition: all var(--interview-transition-base);
  letter-spacing: -0.01em;
  font-family: var(--interview-font-primary);
}

.support-closeButtonBottom:hover {
  background: var(--interview-brand-primary-hover);
  transform: translateY(-1px);
  box-shadow: var(--interview-shadow-button);
}

.support-closeButtonBottom:active {
  transform: translateY(0);
}

/* Responsive */
@media (max-width: 768px) {
  .support-overlay {
    padding: 12px;
  }

  .support-modal {
    border-radius: 12px;
  }

  .support-header {
    padding: 20px 24px;
  }

  .support-title {
    font-size: 20px;
  }

  .support-content {
    padding: 24px;
  }

  .support-intro {
    font-size: 14px;
    margin-bottom: 20px;
  }

  .support-contacts {
    gap: 16px;
  }

  .support-contactItem {
    padding: 14px;
  }

  .support-contactName {
    font-size: 14px;
  }

  .support-contactEmail {
    font-size: 13px;
  }

  .support-footer {
    padding: 16px 24px;
  }

  .support-closeButtonBottom {
    width: 100%;
    padding: 14px 24px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Interview/ContactSupportModal/ContactSupportModal.css"],"names":[],"mappings":"AAAA;;+CAE+C;;AAI/C,kCAAkC;AAClC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;EACjC,kCAAkC;EAClC,mEAAmE;EACnE,0CAA0C;AAC5C;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA,oBAAoB;AACpB;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,0CAA0C;EAC1C,oEAAoE;AACtE;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,8DAA8D;EAC9D,wDAAwD;AAC1D;;AAEA;EACE,iBAAiB;EACjB,uCAAuC;EACvC,oCAAoC;EACpC,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kCAAkC;EAClC,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;EACzC,gDAAgD;EAChD,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA,YAAY;AACZ;EACE,mCAAmC;AACrC;;AAEA;EACE,qCAAqC;EACrC,kCAAkC;EAClC,wCAAwC;EACxC,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,yCAAyC;EACzC,iDAAiD;EACjD,gDAAgD;AAClD;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,oCAAoC;EACpC,wCAAwC;EACxC,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,qBAAqB;EACrB,qBAAqB;EACrB,gDAAgD;EAChD,yCAAyC;AAC3C;;AAEA;EACE,0CAA0C;EAC1C,0BAA0B;AAC5B;;AAEA,WAAW;AACX;EACE,6DAA6D;EAC7D,qDAAqD;EACrD,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;EAC1C,gCAAgC;EAChC,YAAY;EACZ,yCAAyC;EACzC,uCAAuC;EACvC,qCAAqC;EACrC,2CAA2C;EAC3C,eAAe;EACf,gDAAgD;EAChD,uBAAuB;EACvB,0CAA0C;AAC5C;;AAEA;EACE,gDAAgD;EAChD,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,eAAe;AACf;EACE;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;AACF","sourcesContent":["/* ==========================================\n   CONTACT SUPPORT MODAL - G42 BRANDING\n   ========================================== */\n\n@import '../../../styles/interview-theme.css';\n\n/* Contact Support Modal Overlay */\n.support-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: var(--interview-z-modal);\n  padding: var(--interview-space-xl);\n  animation: support-fadeIn var(--interview-transition-base) ease-out;\n  font-family: var(--interview-font-primary);\n}\n\n@keyframes support-fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n/* Modal Container */\n.support-modal {\n  background: var(--interview-bg-white);\n  border-radius: var(--interview-radius-2xl);\n  max-width: 520px;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n  animation: support-slideUp var(--interview-transition-slow) ease-out;\n}\n\n@keyframes support-slideUp {\n  from {\n    transform: translateY(30px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n/* Header */\n.support-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--interview-space-2xl) var(--interview-space-3xl);\n  border-bottom: 1px solid var(--interview-border-default);\n}\n\n.support-title {\n  font-size: 1.5rem;\n  font-weight: var(--interview-text-bold);\n  color: var(--interview-text-primary);\n  margin: 0;\n  letter-spacing: -0.02em;\n}\n\n.support-closeButton {\n  background: none;\n  border: none;\n  font-size: 2rem;\n  color: var(--interview-text-muted);\n  cursor: pointer;\n  padding: 0;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: var(--interview-radius-sm);\n  transition: all var(--interview-transition-base);\n  line-height: 1;\n}\n\n.support-closeButton:hover {\n  background: var(--interview-bg-card);\n  color: var(--interview-text-primary);\n}\n\n/* Content */\n.support-content {\n  padding: var(--interview-space-3xl);\n}\n\n.support-intro {\n  font-size: var(--interview-text-base);\n  color: var(--interview-text-muted);\n  margin: 0 0 var(--interview-space-2xl) 0;\n  line-height: 1.6;\n  font-weight: var(--interview-text-regular);\n}\n\n.support-contacts {\n  display: flex;\n  flex-direction: column;\n  gap: var(--interview-space-xl);\n}\n\n.support-contactItem {\n  padding: var(--interview-space-lg);\n  background: var(--interview-bg-card);\n  border-radius: var(--interview-radius-md);\n  border: 1px solid var(--interview-border-default);\n  transition: all var(--interview-transition-base);\n}\n\n.support-contactItem:hover {\n  background: var(--interview-bg-input);\n  border-color: var(--interview-border-light);\n}\n\n.support-contactName {\n  font-size: var(--interview-text-base);\n  font-weight: var(--interview-text-semibold);\n  color: var(--interview-text-primary);\n  margin-bottom: var(--interview-space-sm);\n  letter-spacing: -0.01em;\n}\n\n.support-contactEmail {\n  font-size: 0.875rem;\n  color: var(--interview-brand-primary);\n  text-decoration: none;\n  display: inline-block;\n  transition: all var(--interview-transition-base);\n  font-weight: var(--interview-text-medium);\n}\n\n.support-contactEmail:hover {\n  color: var(--interview-brand-primary-dark);\n  text-decoration: underline;\n}\n\n/* Footer */\n.support-footer {\n  padding: var(--interview-space-xl) var(--interview-space-3xl);\n  border-top: 1px solid var(--interview-border-default);\n  display: flex;\n  justify-content: flex-end;\n}\n\n.support-closeButtonBottom {\n  background: var(--interview-brand-primary);\n  color: var(--interview-bg-white);\n  border: none;\n  border-radius: var(--interview-radius-md);\n  padding: var(--interview-space-md) 28px;\n  font-size: var(--interview-text-base);\n  font-weight: var(--interview-text-semibold);\n  cursor: pointer;\n  transition: all var(--interview-transition-base);\n  letter-spacing: -0.01em;\n  font-family: var(--interview-font-primary);\n}\n\n.support-closeButtonBottom:hover {\n  background: var(--interview-brand-primary-hover);\n  transform: translateY(-1px);\n  box-shadow: var(--interview-shadow-button);\n}\n\n.support-closeButtonBottom:active {\n  transform: translateY(0);\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .support-overlay {\n    padding: 12px;\n  }\n\n  .support-modal {\n    border-radius: 12px;\n  }\n\n  .support-header {\n    padding: 20px 24px;\n  }\n\n  .support-title {\n    font-size: 20px;\n  }\n\n  .support-content {\n    padding: 24px;\n  }\n\n  .support-intro {\n    font-size: 14px;\n    margin-bottom: 20px;\n  }\n\n  .support-contacts {\n    gap: 16px;\n  }\n\n  .support-contactItem {\n    padding: 14px;\n  }\n\n  .support-contactName {\n    font-size: 14px;\n  }\n\n  .support-contactEmail {\n    font-size: 13px;\n  }\n\n  .support-footer {\n    padding: 16px 24px;\n  }\n\n  .support-closeButtonBottom {\n    width: 100%;\n    padding: 14px 24px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
